import { render, staticRenderFns } from "./right-center.vue?vue&type=template&id=4a3e06ac&scoped=true&"
import script from "./right-center.vue?vue&type=script&lang=js&"
export * from "./right-center.vue?vue&type=script&lang=js&"
import style0 from "./right-center.vue?vue&type=style&index=0&id=4a3e06ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3e06ac",
  null
  
)

export default component.exports